import produce from "immer"
import { ACTIVE, ASC } from "const"
import { MtAccount } from "server/models"
import { InferValueTypes } from "client/utils"
import * as types from "./types"
import * as actions from "./actions"

type ActionTypes = ReturnType<InferValueTypes<typeof actions>>

export const initAccount: MtAccount = {
    id: null,
    name: "",
    shortName: "",
    logoId: null,
    url: "",
    demoExpiry: null,
    timezone: "GMT",
    status: ACTIVE,
}

const initAccountState: types.AccountState = {
    accountList: null, // important! "null" value is used for login
    accountIds: null,
    accountView: initAccount,
    accountEdit: initAccount,

    sortColumn: "name",
    sortOrder: ASC,
    filters: {
        status: null,
        search: null,
    },

    reloadList: true,
    reloadView: true,
    reloadEdit: true,
}

const accountReducer = produce((
    draft: types.AccountState = initAccountState,
    action: ActionTypes = null,
): types.AccountState => {
    switch (action.type) {
        case types.ACCOUNT_LIST:
            draft.accountList = action.accountList
            return draft

        case types.ACCOUNT_IDS:
            draft.accountIds = action.accountIds
            return draft

        case types.ACCOUNT_VIEW:
            draft.accountView = action.account
            return draft

        case types.ACCOUNT_EDIT:
            draft.accountEdit = action.account
            return draft

        case types.ACCOUNT_SORT:
            draft.sortColumn = action.sortColumn
            draft.sortOrder = action.sortOrder
            return draft

        case types.ACCOUNT_FILTERS:
            draft.filters = action.filters
            return draft

        case types.ACCOUNT_RELOAD_LIST:
            draft.reloadList = action.value
            return draft

        case types.ACCOUNT_RELOAD_VIEW:
            draft.reloadView = action.value
            return draft

        case types.ACCOUNT_RELOAD_EDIT:
            draft.reloadEdit = action.value
            return draft

        default:
            return draft
    }
})
export default accountReducer
